module.exports = __webpack_public_path__ + "static/media/poste_16.593b2dfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_16.jpg
// module id = 244
// module chunks = 0